export const EXPERIMENTS = {
  DOUBLE_OPT_IN_SETTING: 'specs.forms.DoubleOptInSettings',
  DYNAMIC_SUBDIVISIONS: 'specs.forms.DynamicSubdivisions',
  ENABLE_DEXT_PHONE_INPUT: 'specs.forms.EnableDextPhoneField',
  ENABLE_PHONE_FIELD: 'specs.forms.EnablePhoneField',
  ENABLE_ARCHIVE_FORMAT: 'specs.forms.FileUploadArchiveFormat',
  OVERRIDE_MLA_FIELD_IDS: 'specs.forms.OverrideMLAFieldIds',
  ENABLE_NEW_PHONE_FIELD_VALIDATION: 'specs.forms.EnableNewPhoneFieldValidation',
  GLOBAL_SUBMIT_SETTINGS_VIEWER: 'specs.forms.GlobalSubmitSettingsViewer',
  ENABLE_ADVANCED_PHONE_SETTINGS: 'specs.forms.EnableAdvancedPhoneSettings'
};
//# sourceMappingURL=experiments.js.map